import { useState } from "react"
import AdminNavBar from "./AdminNavBar"
import LocationNavBar from "./LocationNavBar"

const AddLocation = () => {
	const [locationShortName, setLocationShortName] = useState("")
	const [locationLongName, setLocationLongName] = useState("")
	const [msg, setMsg] = useState("")
	
	const handleSubmit = async () => {
		if (locationShortName === "" || locationLongName === "") {
			setMsg("Location short name and long name cannot be empty")
			return
		} else {
			const formData = new FormData()
			formData.append("short_name", locationShortName)
			formData.append("long_name", locationLongName)
			
			
			const resp = await fetch(process.env.REACT_APP_API+"/api/locations", {
				method: "POST",
				body: formData
			});
			
			if (resp.status === 200) {
				setMsg("Added " + locationShortName + " successfully")
			} else {
				setMsg("Failed to add " + locationShortName)
			}
			setLocationLongName("")
			setLocationShortName("")
		}
	}
	
	return (
		<div className="resilire">
			<AdminNavBar />
			<LocationNavBar />


				<h3>Add Location</h3>

					<label htmlFor="locationShortName">Location Short Name</label>
					<input id="locationShortName" type="text" value={locationShortName} onChange={(e) => setLocationShortName(e.target.value)} />

					<label htmlFor="locationLongName">Location Long Name</label>
					<input id="locationLongName" type="text" value={locationLongName} onChange={(e) => setLocationLongName(e.target.value)} />

				<button onClick={handleSubmit}>Submit</button>
				<p>{msg}</p>

		</div>
	)
}

export default AddLocation;
